<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-7">
        <div class="card h-100 mb-4">
          <div class="card-header pb-0 px-3">
            <div class="row">
              <div class="col-md-6">
                <h6 class="mb-0">Procesos Asignados</h6>
              </div>
              <div class="col-md-6 d-flex justify-content-end align-items-center">
                <small v-if="primary_process_user.length > 0">
                  <i class="far fa-calendar-alt me-2" aria-hidden="true"></i>
                  {{ primary_process_user.length }} Procesos
                </small>
              </div>
            </div>
          </div>
          <div class="card-body pt-4 p-3">
            <soft-alert v-if="primary_process_user.length === 0" color="info" icon="fas fa-info-circle">
              EL USUARIO NO TIENE PROCESOS ASIGNADOS
            </soft-alert>

            <ul class="list-group">
              <li v-for="(item, index) in primary_process_user" :key="index"
                  class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg"
                  :class="{ 'border-start border-primary border-4': primaryProcessSelected?._id === item._id }">
                <div class="d-flex flex-column w-100">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-2 text-sm">{{ item.main_process_title }}</h6>
                    <soft-badge :color="item.main_process_status ? 'success' : 'warning'" variant="gradient" size="sm">
                      {{ item.main_process_status ? 'COMPLETADO' : 'PENDIENTE' }}
                    </soft-badge>
                  </div>
                  <span class="mb-3 text-xs">
                    Descripción: <span class="text-dark font-weight-bold ms-sm-2">{{ item.main_process_description }}</span>
                  </span>

                  <div class="d-flex justify-content-end gap-2">
                    <soft-button color="info" variant="gradient" size="sm" @click="selectProcessToAddNewSecondaryProcess(item)">
                      <i class="fas fa-plus me-2"></i> Nuevo Subproceso
                    </soft-button>
                    <soft-button color="dark" variant="outline" size="sm" 
                                 type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-' + index">
                      <i class="fas fa-eye me-2"></i> Ver Detalles
                    </soft-button>
                  </div>

                  <div :id="'collapse-' + index" class="collapse mt-3">
                    <hr class="horizontal dark mt-0 mb-3">
                    <div v-if="item.secondary_process && item.secondary_process.length > 0" class="timeline timeline-one-side">
                      <div v-for="(item2, index2) in item.secondary_process" :key="index2" class="timeline-block mb-3">
                        <span class="timeline-step">
                          <i :class="item2.status ? 'fas fa-check text-success' : 'fas fa-clock text-warning'"></i>
                        </span>
                        <div class="timeline-content">
                          <div class="d-flex justify-content-between align-items-start">
                            <div>
                              <h6 class="text-dark text-sm font-weight-bold mb-0">{{ item2.title }}</h6>
                              <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">{{ item2.description }}</p>
                            </div>
                            <div class="d-flex gap-2 flex-wrap align-items-center">
                              <soft-button v-if="!item2.status" color="success" variant="outline" size="sm" 
                                           class="shadow-none mb-0 py-1 px-2 text-xxs" 
                                           title="Aprobar subproceso"
                                           @click="updateStatusSecondaryProcess(item, item2)">
                                <i class="fas fa-check me-1"></i> APROBAR
                              </soft-button>
                              <soft-button v-else color="warning" variant="outline" size="sm" 
                                           class="shadow-none mb-0 py-1 px-2 text-xxs" 
                                           title="Marcar como pendiente"
                                           @click="updateStatusSecondaryProcess(item, item2)">
                                <i class="fas fa-times me-1"></i> PENDIENTE
                              </soft-button>
                              <soft-button color="info" variant="outline" size="sm" 
                                           class="shadow-none mb-0 py-1 px-2 text-xxs" 
                                           title="Eliminar archivo adjunto"
                                           @click="deleteFileSecondaryProcess(item._id, item2.uuid)">
                                <i class="fas fa-file-excel me-1"></i> ARCHIVO
                              </soft-button>
                              <soft-button :color="item2.show_subprocess !== false ? 'info' : 'secondary'" variant="outline" size="sm" 
                                           class="shadow-none mb-0 py-1 px-2 text-xxs" 
                                           :title="item2.show_subprocess !== false ? 'Ocultar subproceso' : 'Mostrar subproceso'"
                                           @click="toggleShowSubprocess(item, item2)">
                                <i :class="item2.show_subprocess !== false ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                              </soft-button>
                              <soft-button color="danger" variant="outline" size="sm" 
                                           class="shadow-none mb-0 py-1 px-2 text-xxs" 
                                           title="Eliminar subproceso"
                                           @click="deleteSecondaryProcess(item._id, item2.uuid)">
                                <i class="fas fa-trash me-1"></i> ELIMINAR
                              </soft-button>
                            </div>
                          </div>
                          <div class="mt-2">
                             <a v-if="item2.file_related" :href="item2.file_related" target="_blank" 
                                class="text-xs text-info font-weight-bold d-flex align-items-center">
                               <i class="fas fa-paperclip me-1"></i> Ver archivo adjunto
                             </a>
                             <span v-else class="text-xs text-secondary italic">Sin archivo</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-center py-3">
                      <p class="text-xs text-secondary mb-0">No hay subprocesos registrados</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="card h-100">
          <div class="card-header pb-0 p-3">
            <h6 class="mb-0">Nuevo Subproceso</h6>
          </div>
          <div class="card-body p-3">
            <soft-alert v-if="!primaryProcessSelected" color="info" icon="fas fa-hand-pointer">
              Seleccione un proceso principal para comenzar
            </soft-alert>
            <div v-else>
              <div class="d-flex align-items-center mb-4">
                <div class="btn btn-icon-only btn-rounded btn-outline-primary mb-0 me-3 btn-sm d-flex align-items-center justify-content-center">
                  <i class="fas fa-tasks"></i>
                </div>
                <div class="d-flex flex-column">
                  <h6 class="mb-1 text-dark text-sm">Parent Process</h6>
                  <span class="text-xs">{{ primaryProcessSelected.main_process_title }}</span>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label ms-0">Título del Subproceso</label>
                <soft-input v-model="formSecondaryProcess.title" placeholder="Ej: Pago de visa" />
              </div>

              <div class="mb-3">
                <label class="form-label ms-0">Descripción</label>
                <soft-input v-model="formSecondaryProcess.description" placeholder="Detalles del paso..." />
              </div>

              <div class="mb-4">
                <label class="form-label ms-0">¿Requiere Archivo?</label>
                <select class="form-control" v-model="formSecondaryProcess.has_file_related">
                  <option value="">Seleccione</option>
                  <option value="SI">Sí, requiere archivo</option>
                  <option value="NO">No requiere</option>
                </select>
              </div>

              <soft-button color="success" variant="gradient" fullWidth @click="addNewSecondaryProcess" class="mt-2">
                <i class="fas fa-plus me-2"></i> Crear Subproceso
              </soft-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { get, post } from "@/utils/httpRequest";
import SoftAlert from "@/components/SoftAlert.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import SoftInput from "@/components/SoftInput.vue";

export default {
  name: "tabApprovedProcess",
  components: {
    SoftAlert,
    SoftButton,
    SoftBadge,
    SoftInput
  },
  data: () => ({
    user_id: null,
    primary_process_user: [],
    primary_process: [],
    primaryProcessSelected: null,
    formSecondaryProcess: {
      title: '',
      description: '',
      has_file_related: ''
    }
  }),
  async mounted() {
    this.user_id = this.$route.query.id
    await this.getMainProcessByUser()
  },
  methods: {
    async getMainProcessByUser() {
      try {
        const { data } = await get(`main-process/get-main-process-by-user?user_id=${this.user_id}`)
        this.primary_process_user = data
        // Update selected process if it exists in the new list to keep UI in sync
        if (this.primaryProcessSelected) {
          const updated = this.primary_process_user.find(p => p._id === this.primaryProcessSelected._id)
          if (updated) this.primaryProcessSelected = updated
        }
      } catch (error) {
        console.error("Error fetching processes:", error)
      }
    },
    async updateStatusSecondaryProcess(item, secondary) {
      try {
        await post(`main-process/update-status-process-assigned`, { _id: item._id, uuid: secondary.uuid })
        await Swal.fire({
          title: 'Estado actualizado',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
        await this.getMainProcessByUser()
      } catch (error) {
        Swal.fire('Error', 'No se pudo actualizar el estado', 'error')
      }
    },
    async deleteFileSecondaryProcess(_id, secondary_id) {
      const result = await Swal.fire({
        title: '¿Eliminar archivo?',
        text: "Esta acción no se puede deshacer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      })

      if (result.isConfirmed) {
        try {
          await post("main-process/delete-file-related-secondary-process", { id: _id, secondary_id: secondary_id })
          await this.getMainProcessByUser()
          Swal.fire('Eliminado', 'El archivo ha sido eliminado.', 'success')
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar el archivo', 'error')
        }
      }
    },
    async deleteSecondaryProcess(_id, secondary_id) {
      const result = await Swal.fire({
        title: '¿Eliminar subproceso?',
        text: "Se eliminará permanentemente de este usuario",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#82d616',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      })

      if (result.isConfirmed) {
        try {
          await post("main-process/delete-secondary-process", { id: _id, secondary_id: secondary_id })
          await this.getMainProcessByUser()
          Swal.fire('Eliminado', 'El subproceso ha sido eliminado.', 'success')
        } catch (error) {
          Swal.fire('Error', 'No se pudo eliminar el subproceso', 'error')
        }
      }
    },
    async toggleShowSubprocess(item, secondary) {
      try {
        const newValue = secondary.show_subprocess === false ? true : false;
        await post(`main-process/update-show-subprocess-status`, {
          _id: item._id,
          uuid: secondary.uuid,
          show_subprocess: newValue
        });
        
        await Swal.fire({
          title: 'Visibilidad actualizada',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000
        });
        
        await this.getMainProcessByUser();
      } catch (error) {
        Swal.fire('Error', 'No se pudo actualizar la visibilidad', 'error');
      }
    },
    selectProcessToAddNewSecondaryProcess(item) {
      this.primaryProcessSelected = item
    },
    async addNewSecondaryProcess() {
      if (this.primaryProcessSelected && this.formSecondaryProcess.title && this.formSecondaryProcess.description) {
        try {
          await post('main-process/users-process-add-new-secondary-process', {
            title: this.formSecondaryProcess.title,
            description: this.formSecondaryProcess.description,
            has_file_related: this.formSecondaryProcess.has_file_related,
            main_process_id: this.primaryProcessSelected._id
          })
          
          await Swal.fire('Éxito', 'Subproceso creado correctamente', 'success')
          
          // Reset form
          this.formSecondaryProcess = { title: '', description: '', has_file_related: '' }
          
          // Refresh data without reload
          await this.getMainProcessByUser()
        } catch (error) {
          Swal.fire('Error', 'No se pudo crear el subproceso', 'error')
        }
      } else {
        Swal.fire('Campos incompletos', 'Por favor complete todos los campos requeridos', 'warning')
      }
    }
  }
}
</script>

<style scoped>
/* Timeline styles for better visualization */
.timeline {
  position: relative;
  padding: 1rem 0;
}
.timeline-block {
  position: relative;
  padding-left: 3rem;
}
.timeline-block:last-child {
  margin-bottom: 0 !important;
}
.timeline-step {
  position: absolute;
  left: 0;
  width: 2rem;
  height: 2rem;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.timeline-one-side:before {
  content: "";
  position: absolute;
  top: 0;
  left: 1rem;
  height: 100%;
  width: 2px;
  background: #e9ecef;
  z-index: 1;
}
@media (min-width: 992px) {
  .timeline-one-side .timeline-content {
      max-width: 100% !important;
  }
}
</style>
